import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage content-grid--subpage-table" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { key: 1 }

import {computed, onMounted, ref, watch} from "vue";
import {useI18n} from "vue3-i18n";
import Card from '@/components/layout/Card.vue';
import SearchInput from "@/components/layout/SearchInput.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import FormSelect from "@/components/forms/FormSelect.vue";
import FormRow from "@/components/forms/FormRow.vue";
import ActivityRegistrationTable from "@/components/tables/ActivityRegistrationTable.vue";
import {useActivityOccurrenceService, useActivityService} from "@/inversify.config";
import {Activity, ActivityRegistration} from "@/types/entities/activity";
import {ActivityOccurrence} from "@/types/entities/activity/activityOccurrence";
import {ComputedRef} from "vue/dist/vue";
import {FormOption} from "@/types";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminActivityOccurrenceRegistrations',
  props: {
    activityId: {}
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props

const {t} = useI18n();

const activityService = useActivityService();
const activityOccurrenceService = useActivityOccurrenceService()

const selectedActivityId = ref(props.activityId ?? "")
const activities = ref<Activity[]>((
  ([__temp,__restore] = _withAsyncContext(() => activityService.getAllActivities())),
  __temp = await __temp,
  __restore(),
  __temp
) ?? [])
const selectedActivity = ref<Activity>(findActivityWithId(selectedActivityId.value))

const activityOccurrences = ref<ActivityOccurrence[]>(selectedActivity.value ? selectedActivity.value.activityOccurrences : [])
const selectedActivityOccurrence = ref<ActivityOccurrence>(activityOccurrences.value.length > 0 ? activityOccurrences.value[0] as ActivityOccurrence : new ActivityOccurrence())
const selectedActivityOccurrenceId = ref(selectedActivityOccurrence.value.id ?? "")

const registrations = ref<ActivityRegistration[]>([]);
const registrationsAreLoading = ref(false);
const registrationsSearchValue = ref("");

onMounted(async () => {
  await fetchActivityRegistrations()
})

let activitiesOptions: ComputedRef<FormOption[]> = computed(() => {
  let formOptions = activities.value
      .filter(x => x && x.id && x.nameFr)
      .map(({id, nameFr}) => ({
        name: id,
        label: nameFr
      })) as FormOption[]
  return formOptions.sortByLabel()
});

let activityOccurrencesOptions: any = computed(() => {
  if (activityOccurrences.value.length === 0)
    return []
  return activityOccurrences.value
      .filter(x => x && x.id && x.startDate)
      .map(x => {
        let startDate = x.startDate ? x.startDate : ""
        let endDate = x.endDate ? ` ---> ${x.endDate}` : ''
        return {
          name: x.id,
          label: `${startDate}${endDate}`
        }
      });
});

watch(selectedActivityId, (newId) => {
  registrations.value = []
  selectedActivity.value = findActivityWithId(newId)

  activityOccurrences.value = selectedActivity.value.activityOccurrences
  if (activityOccurrences.value.length === 0)
    return
  selectedActivityOccurrence.value = activityOccurrences.value[0] as ActivityOccurrence
  selectedActivityOccurrenceId.value = activityOccurrences.value[0].id as string
})

watch(selectedActivityOccurrenceId, async () => {
  await fetchActivityRegistrations()
})

async function fetchActivityRegistrations() {
  registrationsAreLoading.value = true
  registrations.value = await activityOccurrenceService.getActivityOccurrenceRegistrations(selectedActivityOccurrenceId.value);
  registrationsAreLoading.value = false
}

function findActivityWithId(id: string): Activity {
  return activities.value.find(x => x.id == id) as Activity;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.activities.registrations.add.name`)
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BackLinkTitle, {
        title: _unref(t)(`routes.admin.children.activities.registrations.add.name`)
      }, null, 8, ["title"]),
      (registrations.value.length)
        ? (_openBlock(), _createBlock(SearchInput, {
            key: 0,
            modelValue: registrationsSearchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registrationsSearchValue).value = $event)),
            class: "util--ml-auto"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Card, {
      title: _unref(t)('activities.selectAnActivity')
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_3, [
          _createVNode(FormRow, null, {
            default: _withCtx(() => [
              _createVNode(FormSelect, {
                modelValue: selectedActivityId.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedActivityId).value = $event)),
                label: _unref(t)('activities.activity'),
                options: _unref(activitiesOptions),
                rules: [],
                name: "activityId"
              }, null, 8, ["modelValue", "label", "options"]),
              (selectedActivityId.value)
                ? (_openBlock(), _createBlock(FormSelect, {
                    key: 0,
                    modelValue: selectedActivityOccurrenceId.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedActivityOccurrenceId).value = $event)),
                    label: _unref(t)('activities.selectAnOccurrence'),
                    options: _unref(activityOccurrencesOptions),
                    rules: [],
                    name: "activityOccurrenceId"
                  }, null, 8, ["modelValue", "label", "options"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    (selectedActivityOccurrenceId.value.length)
      ? (_openBlock(), _createBlock(Card, {
          key: 0,
          title: _unref(t)('registrations.registrations')
        }, {
          default: _withCtx(() => [
            (registrations.value.length)
              ? (_openBlock(), _createBlock(ActivityRegistrationTable, {
                  key: 0,
                  "activity-occurrence-id": selectedActivityOccurrenceId.value,
                  "onUpdate:activityOccurrenceId": _cache[3] || (_cache[3] = ($event: any) => ((selectedActivityOccurrenceId).value = $event)),
                  registrations: registrations.value,
                  "onUpdate:registrations": _cache[4] || (_cache[4] = ($event: any) => ((registrations).value = $event)),
                  registrationsAreLoading: registrationsAreLoading.value,
                  "onUpdate:registrationsAreLoading": _cache[5] || (_cache[5] = ($event: any) => ((registrationsAreLoading).value = $event)),
                  registrationsSearchValue: registrationsSearchValue.value,
                  "onUpdate:registrationsSearchValue": _cache[6] || (_cache[6] = ($event: any) => ((registrationsSearchValue).value = $event)),
                  onRegistrationDeleted: fetchActivityRegistrations
                }, null, 8, ["activity-occurrence-id", "registrations", "registrationsAreLoading", "registrationsSearchValue"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('registrations.emptyRegistrations')), 1))
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})